// extracted by mini-css-extract-plugin
export default {"fallback":"Fallback_fallback__PloLt"};